<template>
  <form class="contact-search--form" @submit.prevent="submit">
    <v-layout row wrap>
      <v-flex xs12>
        <TextInputCommon
          v-model="searchEmail"
          :validations="{ required: true, email: true }"
          display-name="Email Address"
          ref="email-input" />
      </v-flex>

      <v-flex xs12>
        <ButtonCommon
          :disabled="loading"
          block
          ref="submit-button"
          type="submit"
          variant="secondary">
          Search
        </ButtonCommon>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
import ButtonCommon from '@/components/common/ButtonCommon.vue';
import TextInputCommon from '@/components/common/TextInputCommon.vue';
import FormMixin from '@/mixins/FormMixin';

export default {
  $_veeValidate: {
    validator: 'contact-search',
  },
  mixins: [FormMixin],
  components: {
    ButtonCommon,
    TextInputCommon,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchEmail: this.email,
    };
  },
  methods: {
    async submit() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.$emit('submit', this.searchEmail);
      }
    },
  },
};
</script>
